import { Box, styled } from '@mui/material';
import { Popup } from '@elements';
import { pxToRem } from '@themes';
var StyledPopup = styled(Popup)(function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.palette.mirage.main,
    borderRadius: pxToRem(24),
    padding: theme.spacing(4.75, 3)
  };
});
var StyledHeader = styled(Box)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: 'flex',
    justifyContent: 'center'
  };
});
var StyledContent = styled(Box)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: 'flex',
    alignItems: 'center'
  };
});
export { StyledContent, StyledHeader, StyledPopup };